import { useState } from "react";
import { Box, Card, Grid, useTheme } from "@mui/material";
import CustomCardWrapper from "../../../common/contentType/CustomCardWrapper";
import { TypographyWithMore } from "../../../common";
import ZoomCalendarVButtons from "./zoom-calendar-components/ZoomCalendarVButtons";

const ZoomCalendarVertical = ({ content }) => {
    const theme = useTheme();
    const { name, description } = content?.allContent;
    let tempContent = JSON.parse(content?.allContent?.content)
    const { image } = tempContent

    return (
        <CustomCardWrapper>
            <Grid container height="100%" spacing={{ xs: 1, md: 4 }} width="100%">
                <Grid item xs={12} md={6} display="flex" flexDirection="column" justifyContent='center'>
                    {!!name && (
                        <Card
                            sx={{
                                backgroundColor: theme.palette.primary.main,
                                borderRadius: ".8rem",
                                boxShadow: "none",
                                width: "100%",
                                p: ".5rem",
                                mb: "1rem",
                            }}
                        >
                            <TypographyWithMore
                                variant="h2"
                                color={"white"}
                                data={name}
                                textLength={10}
                                lines={2}
                                width="100%"
                            />
                        </Card>
                    )}
                    <TypographyWithMore
                        marginLeft={2}
                        variant="subTitle1"
                        color="text"
                        data={description}
                        textLength={120}
                        lines={15}
                    />
                    <ZoomCalendarVButtons meetingDetails={tempContent} />
                </Grid>
                <Grid item xs={12} md={6} display="flex" justifyContent="center" alignItems='center'>
                    <Box mt={{ xs: "1rem", md: "" }} sx={{ width: '100%', height: "50vh", aspectRatio: '2/3', boxShadow: 3 }}>
                        <img
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: 'cover'
                            }}
                            src={image}
                            alt="Image"
                        />
                    </Box>
                </Grid>
            </Grid>
        </CustomCardWrapper>
    );
};

export default ZoomCalendarVertical;
